import { useState } from 'react';
import { faqData } from '@/mocks/home';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-50 text-accent-700 text-xs font-medium mb-4">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            关于亚洲在线的常见疑问
          </h2>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div
                  className={`w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-full transition-colors ${
                    openIndex === index
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-500'
                  }`}
                >
                  <i className={`text-sm ${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}